import moment from 'moment';
import React from 'react';

import PaginatedSchoolSlider from '@/components/ResourcesPage/SchoolsPage/PaginatedSchoolSlider';

import PaginatedBookSlider from '../../BookComp/PaginatedBookSlider';
import PaginatedCoursesSlider from '../../Courses/PaginatedCoursesSlider';

interface Props {
  category: string | undefined;
  token: string;
  type?: 'book' | 'course' | 'school';
}

const RecommendedBooksSection: React.FC<Props> = ({
  category,
  token,
  type = 'book',
}) => {
  const isStaging = process.env.NEXT_PUBLIC_APP_ENV === 'staging';
  const categoryIdFilter = isStaging
    ? '66d95bde2da439ae0a02b8b0'
    : '66c6db9e104ce84c7e2a8956';

  const nowMinus6Months = moment().subtract(6, 'months').format('YYYY-MM-DD');

  const sliderSections: {
    key: string;
    types: string[];
    render: () => React.ReactNode;
  }[] = [
    {
      key: 'school-section',
      types: ['school'],
      render: () => (
        <PaginatedSchoolSlider
          category_name={category}
          categoryName={`More Schools in ${category} Category`}
          notBookLandingPage={false}
        />
      ),
    },

    {
      key: 'book-section',
      types: ['book'],
      render: () =>
        category && (
          <>
            <PaginatedBookSlider
              category_name={category}
              categoryId={null}
              categoryName='Recommended Books for You'
              order='asc'
              notBookLandingPage={false}
            />
            <PaginatedCoursesSlider
              token={token}
              categoryId={category}
              categoryName={category}
              name='Recommended Courses for You'
              notBookLandingPage={false}
            />
          </>
        ),
    },

    {
      key: 'bestseller',
      types: ['book', 'course'],
      render: () => (
        <PaginatedBookSlider
          categoryId={null}
          categoryName='ZebraLearn Bestseller'
          isHomePage
          order='asc'
          categoryIdFilter={categoryIdFilter}
          notBookLandingPage={false}
        />
      ),
    },
    {
      key: 'recent-launch',
      types: ['book', 'course', 'school'],
      render: () => (
        <PaginatedBookSlider
          categoryId={null}
          categoryName='Recently Launched Books'
          isHomePage
          order='asc'
          categoryIdFilter={categoryIdFilter}
          notBookLandingPage={false}
          endDateFilter={nowMinus6Months}
        />
      ),
    },
    {
      key: 'recent-viewed',
      types: ['book', 'course', 'school'],
      render: () => (
        <PaginatedBookSlider
          categoryId={null}
          categoryName='Recently Viewed Books'
          isHomePage
          order='asc'
          isRecentlyViewed
          notBookLandingPage={false}
        />
      ),
    },
  ];

  return (
    <div className='flex flex-col gap-y-8'>
      {sliderSections
        .filter((section) => section.types.includes(type))
        .map((section) => (
          <React.Fragment key={section.key}>{section.render()}</React.Fragment>
        ))}
    </div>
  );
};

export default RecommendedBooksSection;
